export default __webpack_public_path__ + "static/Immerse yourself in mandarin media-ce3ff4b758a065be62dc6ec1f68a6130.jpg";